import { IUserData } from "shared/entities/aaa/IUserData";
import { FsEntity } from "../../utils/Fs";

export class CurrentUserEntity extends FsEntity<IUserData> {

}